import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import _truncate from 'lodash/truncate';

import MenuItem from '@material-ui/core/MenuItem';

import combineStyles from '../../utils/combineStyles';
import TypographyStyles from '../../styles/typography';

import NotificationsCircle from './NotificationsCircle';
import NotificationItemStyles from './__styles__/NotificationItem.styles';

import { MAX_CHARACTERS_DISPLAYED } from '../../constants/constants';

export class NotificationItem extends PureComponent {
  _handleClick = () => {
    this.props.onClick(this.props.id);
  };

  render() {
    const {
      classes,
      title,
      headerMessage,
      content,
      createdAt,
      status,
      link,
      displayMore
    } = this.props;

    return (
      <MenuItem
        className={classnames(classes.menuItem, {
          [classes.menuItemDone]: status === 'done'
        })}
        onClick={link ? this._handleClick : null}
        disableRipple={displayMore}
        classes={{
          root: classnames({
            [classes.menuItemCursorPointer]: link
          })
        }}
      >
        <div
          className={classnames(classes.wrapper, 'wrapper', {
            [classes.noEvents]: link
          })}
        >
          <div className={classes.content}>
            <div className={classes.notificationContainer}>
              <NotificationsCircle
                classes={{
                  root: classes.notificationsCircle,
                  icon: classnames({
                    [classes.notificationsCircleRead]: status === 'read',
                    [classes.notificationsCircleDone]: status === 'done'
                  })
                }}
              />
            </div>
            <div>
              <p
                className={classnames(classes.subject, classes.caption, {
                  [classes.subjectDone]: status === 'done'
                })}
              >
                <strong>{title}</strong>
                {_truncate(headerMessage, {
                  length: MAX_CHARACTERS_DISPLAYED,
                  separator: ' '
                })}
              </p>
              {content && (
                <p
                  className={classnames(classes.subject, classes.caption, {
                    [classes.subjectDone]: status === 'done'
                  })}
                >
                  {`"${_truncate(content, {
                    length: MAX_CHARACTERS_DISPLAYED,
                    separator: ' '
                  })}"`}
                </p>
              )}
              <p className={classnames(classes.footer, classes.caption)}>
                <span className={classes.createdAt}>{createdAt}</span>
                {displayMore && (
                  <button
                    type="button"
                    className={classnames(classes.readMore, {
                      [classes.subjectDone]: status === 'done'
                    })}
                    onClick={displayMore ? this._handleClick : null}
                  >
                    Read More
                  </button>
                )}
              </p>
            </div>
          </div>
        </div>
      </MenuItem>
    );
  }
}

export default withStyles(
  combineStyles(TypographyStyles, NotificationItemStyles)
)(NotificationItem);
